<template>
    <l-card-content>
        <l-headline
            :tabs="tabs"
            :title="$t('surveys.details.titleEmail')"
            :sub-title="survey.name ? survey.name : $t('surveys.details.labelNewSurvey')"
            :auto-save-text="autoSavingText"
            btn-test-id="surveys-create"
        >
        </l-headline>

        <hr class="visible-xs" />

        <!-- KICKOFF -->

        <h4 class="color-dark">
            <strong
                ><span>{{ $t("surveys.details.subtitleKickoffNotification") }}</span>
            </strong>
        </h4>

        <p>
            <span>{{ $t("surveys.details.helpKickoffNotification") }}</span>
        </p>

        <div class="row">
            <div class="col-md-9">
                <form name="kickoff-email">
                    <label class="color-dark">
                        <input
                            v-model="survey.kickoffEmailType"
                            type="radio"
                            name="kickoffEmailType"
                            value="default"
                            @change="
                                () => {
                                    survey.kickoffEmail = {};
                                    updateSurvey(); // we should auto save
                                }
                            "
                        />

                        <span class="l-default-margin-s">{{
                            $t("surveys.details.labelDefaultEmail")
                        }}</span>
                    </label>
                    <br />
                    <label class="color-dark">
                        <input
                            v-model="survey.kickoffEmailType"
                            data-test-id="survey-kickoff-email-type-custom"
                            type="radio"
                            name="kickoffEmailType"
                            value="custom"
                            @change="
                                () => {
                                    $forceUpdate();
                                    // we only need to update UI, autoSave should happen when there is content.
                                    if (!survey.kickoffEmail) {
                                        survey.kickoffEmail = {
                                            subject: '',
                                            body: '',
                                        };
                                    }
                                }
                            "
                        />

                        <span class="l-default-margin-s">{{
                            $t("surveys.details.labelCustomEmail")
                        }}</span>
                    </label>
                    <br />
                    <br />
                </form>
            </div>
        </div>
        <div class="row">
            <div v-if="survey.kickoffEmailType == 'custom'" class="col-md-9">
                <l-input-text
                    v-model="survey.kickoffEmail.subject"
                    data-test-id="survey-kickoff-email-subject"
                    :label="$t(`surveys.details.labelCustomEmailSubject`)"
                    :placeholder="``"
                    @input="
                        () => {
                            $forceUpdate();
                            if (
                                survey.kickoffEmail &&
                                survey.kickoffEmail.subject != '' &&
                                survey.kickoffEmail.body != ''
                            ) {
                                debouncedUpdateSurvey();
                            }
                        }
                    "
                ></l-input-text>
                <l-input-text
                    v-model="survey.kickoffEmail.body"
                    data-test-id="survey-kickoff-email-body"
                    :label="$t(`surveys.details.labelCustomEmailBody`)"
                    :placeholder="``"
                    type="textarea"
                    @input="
                        () => {
                            $forceUpdate();
                            if (
                                survey.kickoffEmail &&
                                survey.kickoffEmail.subject != '' &&
                                survey.kickoffEmail.body != ''
                            ) {
                                debouncedUpdateSurvey();
                            }
                        }
                    "
                ></l-input-text>
            </div>
        </div>

        <button
            v-if="survey.status != 'closed'"
            class="btn btn-framed"
            @click="sendNotificationPreview('kickoff')"
        >
            <span v-if="!previewNotificationSend.kickoff">{{
                $t("surveys.details.btnNotificationPreview")
            }}</span>
            <span v-else>{{ $t("surveys.details.notificationPreviewSent") }}</span>
        </button>

        <br />

        <!-- REMINDERS -->

        <h4 class="color-dark">
            <strong
                ><span>{{ $t("surveys.details.subtitleReminderNotification") }}</span></strong
            >
        </h4>

        <p>
            <span>{{ $t("surveys.details.helpRemindersNotification") }}</span>
        </p>

        <div class="row">
            <div class="col-md-9">
                <form name="reminder-email">
                    <label class="color-dark">
                        <input
                            v-model="survey.reminderEmailType"
                            name="reminderEmailType"
                            type="radio"
                            value="default"
                            @change="
                                () => {
                                    survey.reminderEmail = {
                                        subject: '',
                                        body: '',
                                    };
                                    updateSurvey();
                                }
                            "
                        />

                        <span class="l-default-margin-s">{{
                            $t("surveys.details.labelDefaultEmail")
                        }}</span>
                    </label>
                    <br />
                    <label class="color-dark">
                        <input
                            v-model="survey.reminderEmailType"
                            name="reminderEmailType"
                            type="radio"
                            value="custom"
                            @change="
                                () => {
                                    $forceUpdate();
                                    if (!survey.reminderEmail) {
                                        survey.reminderEmail = {
                                            subject: '',
                                            body: '',
                                        };
                                    }
                                }
                            "
                        />

                        <span class="l-default-margin-s">{{
                            $t("surveys.details.labelCustomEmail")
                        }}</span>
                    </label>
                    <br />
                    <br />
                </form>
            </div>
        </div>
        <div class="row">
            <div v-if="survey.reminderEmailType == 'custom'" class="col-md-9">
                <l-input-text
                    v-model="survey.reminderEmail.subject"
                    :label="$t(`surveys.details.labelCustomEmailSubject`)"
                    :placeholder="``"
                    @input="
                        () => {
                            $forceUpdate();
                            if (
                                survey.reminderEmail &&
                                survey.reminderEmail.subject != '' &&
                                survey.reminderEmail.body != ''
                            ) {
                                debouncedUpdateSurvey();
                            }
                        }
                    "
                ></l-input-text>
                <l-input-text
                    v-model="survey.reminderEmail.body"
                    :label="$t(`surveys.details.labelCustomEmailBody`)"
                    :placeholder="``"
                    type="textarea"
                    @input="
                        $forceUpdate();
                        if (
                            survey.reminderEmail &&
                            survey.reminderEmail.subject != '' &&
                            survey.reminderEmail.body != ''
                        ) {
                            debouncedUpdateSurvey();
                        }
                    "
                ></l-input-text>
            </div>
        </div>

        <button
            v-if="survey.status != 'closed'"
            class="btn btn-framed"
            @click="sendNotificationPreview('reminder')"
        >
            <span v-if="!previewNotificationSend.reminder">{{
                $t("surveys.details.btnNotificationPreview")
            }}</span>
            <span v-else>{{ $t("surveys.details.notificationPreviewSent") }}</span>
        </button>

        <br />

        <div v-if="survey.status != 'closed'">
            <hr />

            <div v-if="error && error.message" id="error" class="alert alert-info">
                <span>{{ error.message }}</span>
            </div>

            <div class="row">
                <div class="col-md-3 col-md-offset-9">
                    <button
                        class="btn btn-primary btn-raised btn-block"
                        type="button"
                        @click="$router.push(`/surveys/edit/${$route.params.id}/status`)"
                    >
                        <span>{{ $t("surveys.details.btnSaveChanges") }}</span>
                    </button>
                </div>
            </div>
        </div>
    </l-card-content>
</template>

<script>
import { mapGetters } from "vuex";

import LCardContent from "@/components/LCardContent";

import LHeadline from "@/components/LHeadline";
import LInputText from "@/components/LInputText";
import debounce from "lodash.debounce";

import icon from "@/img/icons/surveys.png";

export default {
    components: {
        LCardContent,
        LHeadline,
        LInputText,
    },
    props: {
        autoSavingText: {
            type: String,
            default: "",
        },
        openHelpHC: {
            type: Function,
            default: () => {},
        },
    },
    data() {
        return {
            showOverrideWarning: false,
            survey: {},
        };
    },
    computed: {
        ...mapGetters({
            previewNotificationSend: "surveys/notification/previewSend",
            getDetail: "surveys/surveys/detail",

            error: "surveys/surveys/error",
        }),
        tabs() {
            return [
                {
                    tabClass: "space",
                    show: true,
                },
                {
                    show: true,
                    label: this.$t("surveys.details.showHC"),
                    handler: this.openHelpHC,
                    isButton: true,
                },
            ];
        },
        surveyId() {
            return this.survey._id;
        },
    },
    watch: {
        "$route.params.id": {
            deep: true,
            immediate: true,
            handler(id) {
                this.survey = this.getDetail(id);
                this.survey.kickoffEmailType = this.survey.kickoffEmail ? "custom" : "default";
                this.survey.reminderEmailType = this.survey.reminderEmail ? "custom" : "default";
            },
        },
    },

    created() {
        this.icon = icon;
    },
    methods: {
        sendNotificationPreview(type) {
            this.$store.dispatch("surveys/notification/sendPreview", {
                payload: { data: { type, surveyId: this.surveyId } },
            });
        },
        debouncedUpdateSurvey: debounce(function() {
            this.updateSurvey();
        }, 1000),
        updateSurvey() {
            this.$emit("change", "email", this.survey);
        },
    },
};
</script>

<style scoped></style>
